import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/mapa/step1';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeDept } from '../../../../formulaires/common/models/type.dept';
import { CTRL_1198 } from '../../../../formulaires/validators/1198/ctrl1198';
import { CTRL_237 } from '../../../../formulaires/validators/237/ctrl237';
import { MapaINControlNames } from '../../../../formulaires/mapa/mapa-initial/service/mapaINControleNames';

@Component({
  selector: 'app-type-dept',
  templateUrl: './type-dept.component.html'
})
export class TypeDeptComponent implements OnInit {
  @Input() uid = '';
  @Input() parentForm: FormGroup;
  @Input() deptPublication: TypeDept;
  @Input() disabled: boolean;
  public optionsSelect;
  public optionsSelectType = 'RAPPEL';

  public current_uid = 'TypeDept';
  public rg1 = CTRL_1198.id + '_1';
	public rg2 = CTRL_237.id + '_1';
  public step1 = new Step1();
  public infobulle = '';

  constructor(private autoCompleteService: AutoCompleteService, private translateService: TranslateService) {}

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
		if (!this.deptPublication) {
			this.deptPublication = new TypeDept();

		}
		if (this.deptPublication.rappel === null) {
			this.deptPublication.rappel = [];
		}
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_1198Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_237Names_json() }));
    this.infobulle = this.translateService.instant("eform-editable.infobulle.autre-departement");
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return '_STEP_ID_SepSep_TypeIndexation';
  }

  private getCtrl_1198Names_json(): any {
    const deptPublicationRappel = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel';
    return { firstChamp: deptPublicationRappel };
  }

  private getCtrl_237Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const deptPublicationRappel = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_rappel';
    return { firstChamp: deptPub, secondChamp: deptPublicationRappel };
  }

}
